import { isEmpty } from '@sgme/fp';
import type { IntlKey } from 'locales';
import { IntlShape } from 'react-intl';
import { camelCaseToWords } from 'utils/string';

import type { LanguageIsoCode } from '../../locales';
import translations from '../../locales';

export function translateText(from: LanguageIsoCode, to: LanguageIsoCode, text: string) {
  if (from === to) {
    return text;
  }

  const wordTranslator = makeWordTranslator(from, to);

  return text.split(' ').map(wordTranslator).join(' ');
}

function makeWordTranslator(from: LanguageIsoCode, to: LanguageIsoCode) {
  return (word: string) => {
    if (isEmpty(word.trim())) {
      return word;
    }

    const key = getTranslationKey(word, translations[from] as Record<IntlKey, string>);

    return key ? (translations[to] as Record<IntlKey, string>)[key] : word;
  };
}

function getTranslationKey(text: string, translationMap: Record<IntlKey, string>): IntlKey | undefined {
  return Object.keys(translationMap).find(key => translationMap[key as IntlKey] === text) as IntlKey | undefined;
}

export function getProductLabel(intl: IntlShape, value: string): string {
  return intl.formatMessage({
    id: `quote.products.${value}` as IntlKey,
    defaultMessage: camelCaseToWords(value),
  });
}
